// Color dots on the ScareJam tee cards: swap the card photos and point the card link at that color.
class STeeColor extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-tee-color]');
      if (!swatch || !this.contains(swatch)) return;
      event.preventDefault();
      this.dataset.color = swatch.dataset.teeColor;
      this.querySelectorAll('[data-tee-color]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === swatch));
      });
      if (swatch.dataset.url) {
        this.querySelectorAll('a[href]').forEach((link) => link.setAttribute('href', swatch.dataset.url));
      }
    });
  }
}
if (!customElements.get('s-tee-color')) customElements.define('s-tee-color', STeeColor);
